
export const THEME = {
  spacing: {
    xs: 4,
    s: 8,
    m: 12,
    l: 16,
    xl: 32,
  },
  colors: {
    background: {
      main: "#FFFFFF",
      contrast: "#F2F2F2",
      overlay: "rgba(0, 0, 0, 0.5)",
      primary: "#FFF6E5",
      secondary: "#FDE8E9",
      error: "#FFE5E6",
      success: "#CBE7E0",
    },
    border: {
      main: "#D9D9D9",
      contrast: "#A4A4A4",
      primary: "#DEA133",
      secondary: "#F8B9BE",
      error: "#FFB3B3",
      success: "#0E6C56",
    },
    content: {
      main: "#242424",
      contrast: "#242424",
      primary: "#FFC152",
      secondary: "#EF5E68",
      error: "#930000",
      success: "#047E61",
      above: {
        primary: "#242424",
        main: "#A4A4A4",
        contrast: "#FFFFFF",
        success: "#FFFFFF",
        error: "#FFFFFF",
      }
    },
    interactive: {
      primary: {
        default: "#FFC152",
        hover: "#FFB633"
      },
      main: {
        default: "#FFFFFF",
        hover: "#F2F2F2",
      },
      contrast: {
        default: "#F2F2F2",
        hover: "#F5F5F5",
      },
      success: {
        default: "#047E61",
        hover: "#03634C",
      },
      error: {
        default: "#930000",
        hover: "#03634C",
      }
    }
  }
}